import React from "react";
import {push} from 'react-router-redux';
import {store} from '../../store/store';
import { connect } from 'react-redux';
import personalCenter from '../../services/Employee/personal-center-service.js';
import {Button, Card, PullToRefresh, WhiteSpace, List, InputItem, Toast} from 'antd-mobile';
import MobileWrapper from '../../layouts/MobileWrapper';

class MobileMySalaryList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      dataCount:0,
      data: [],
      pageSize:0,
      cardListRefreshing: false,
      cardListHeight: document.documentElement.clientHeight,
      code: "",
      sent: false,
      verified: false
    }
  }

  componentWillMount() {
    if(!sessionStorage.getItem("smsCode")) {
      this.setState({"verified": false});
      this.sendSms()
    }
    else {
      let smsCode = sessionStorage.getItem("smsCode");
      this.verifySmsCode(smsCode, 1);
    }
  }

  sendSms() {
    personalCenter.sendSms({}, res => {
      console.log(res)
      if(res.data.Success === true) {
        this.setState({"sent": true});
      }
      else {
        Toast.fail(res.data.Errors[0], 4);
        return false;
      }
    }, err => {
    })
  }

  verifySmsCode(smsCode, type) {
    personalCenter.verifySmsCode({code: smsCode}, res => {
      if(res.data.Success === true) {
        this.setState({"verified": true});
        this.setState({"sent": false});
        this.getListData();
      }
      else {
        if(type === 1) {
          this.sendSms();
        }
        else {
          Toast.fail("验证码不正确请重新输入！", 4);
          return false;
        }
      }
    }, err => {
    })
  }

  getListData(gets = {page: 1}) {
    personalCenter.fetchMySalary(gets, res => {
      this.setState({dataCount: res.data.Object.Total})
      this.setState({data: this.state.data.concat(res.data.Object.Data)})
      this.setState({pageSize: res.data.Object.PageSize})

      this.setState({refreshing: false});
    }, err => {
    })
  }

  goToDetail = (params) => {
    var path = {
      pathname:'/mobile/mobile-my-salary-detail',
      state:params,
    }
    store.dispatch(push(path))
  }

  onSubmit = () => {
    if(this.state.code === null){
      Toast.fail("请输入验证码！", 4);
      return false;
    }
    sessionStorage.setItem("smsCode", this.state.code);
    this.verifySmsCode(this.state.code, 2);
  }

  onChange = (value) => {
    this.setState({"code": value});
  }
  render() {

    const self = this;
    const { currentUser } = this.props.user
    var cards = this.state.data.map(function (apply, index) {
      return (
        <div key={index}>
          <WhiteSpace size="lg"/>
          <Card full>
            <Card.Header title={apply.account_monthly} extra=""/>
            <Card.Body>
              <div>基础工资: {apply.current_base_salary}  </div>
              <div>岗位工资: {apply.current_post_salary}  </div>
              <div>应发工资: {apply.wage_payable}</div>
            </Card.Body>
            <Card.Footer content="" extra={<div> <Button style={{width: '140px', float:"right", marginRight: "5px"}} size="small" type="primary" onClick={(e) => self.goToDetail(apply)} >查看详情</Button></div>}/>
          </Card>
        </div>
      );
    });

    return  <div>
      {this.state.sent && <form>
        <List renderHeader={() => '验证码已发送到注册手机号'}>
          <InputItem type="number" placeholder="请输入验证码" value={this.state.code} onChange={this.onChange}>验证码</InputItem>
          <List.Item>
            <div style={{width: '100%', color: '#108ee9', textAlign: 'center'}} onClick={this.onSubmit}>确定</div>
          </List.Item>
        </List>
      </form>}
      {this.state.verified && <PullToRefresh
        ref = {el => this.ptr = el}
        style = {{
          height: this.state.cardListHeight,
          overflow: 'auto',
        }}
        direction = 'up'
        refreshing = {this.state.cardListRefreshing}
        onRefresh = {() => {

          if(this.state.data.length < this.state.dataCount){
            this.setState({refreshing: true});
            this.getListData({page: Math.floor(this.state.data.length/this.state.pageSize) + 1});
          }
        }}
      >
      <div className="sub-title">我的薪资</div>
      {currentUser.PermissionDict.mobile_my_salary_list.r_value && cards}
      </PullToRefresh>}

    </div>
  }
}

// export default MobileWrapper(MobileMySalaryList);
const mapStateToProps = state => {
  return {
    user: state.user
  }
}
const mapDispatchToProps = {
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileMySalaryList));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileMySalaryList.js